import { ErrorInfo } from '../../../shared/interfaces/error-info.interface';
import { ResponseModel } from '../../../shared/interfaces/response-model.interface';
import CompanyMapper from '../../../shared/mappers/company.mapper';
import { ApiResponse } from 'apisauce';
import { CompanyModel } from '../../../shared/models/company.model';
import { CompanyUiModel } from '../../../shared/ui-models/company.ui-model';
import api from '../../../shared/services/utils/api/api.service';
import errorHelper from '../../../shared/services/utils/api/error-helper.service';
import { getModuleName } from './company.service';

export function getAllCompanies(): Promise<CompanyUiModel[] | ErrorInfo> {
  return api
    .getCompanies()
    .then((response: ApiResponse<ResponseModel<CompanyModel[]>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return CompanyMapper.mapToUIList(data.data);
        } else {
          return errorHelper(0, '', getModuleName(), (api.getCompanies as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          getModuleName(),
          (api.getCompanies as any).displayName
        );
      }
    });
}

export function addNewCompany(companyData: CompanyUiModel): Promise<CompanyUiModel | ErrorInfo> {
  const mappedCompany = CompanyMapper.mapToModel(companyData);
  return api
    .createCompany(mappedCompany)
    .then((response: ApiResponse<ResponseModel<CompanyModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return CompanyMapper.mapToUI(data.data);
        } else {
          return errorHelper(0, '', getModuleName(), (api.createCompany as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          getModuleName(),
          (api.createCompany as any).displayName
        );
      }
    });
}

export function updateCompany(
  companyId: string,
  companyData: Partial<CompanyUiModel>
): Promise<CompanyUiModel | ErrorInfo> {
  const mappedCompany = CompanyMapper.mapToModel(companyData as CompanyUiModel);
  return api
    .updateCompany(companyId, mappedCompany)
    .then((response: ApiResponse<ResponseModel<CompanyModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return CompanyMapper.mapToUI(data.data);
        } else {
          return errorHelper(0, '', getModuleName(), (api.updateCompany as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          getModuleName(),
          (api.updateCompany as any).displayName
        );
      }
    });
}

export function deleteCompany(companyId: string): Promise<{} | ErrorInfo> {
  return api
    .deleteCompany(companyId)
    .then((response: ApiResponse<ResponseModel<{}>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return {};
        } else {
          return errorHelper(0, '', getModuleName(), (api.deleteCompany as any).displayName);
        }
      } else {
        return errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          getModuleName(),
          (api.deleteCompany as any).displayName
        );
      }
    });
}
